import $ from "jquery"
import TemplateView from "./TemplateView"
import {getBodyScrollLeft, getBodyScrollTop} from "./atBrowserUtils"
import raf from './util/raf'

export default class Tooltip extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
        this.autoFollowMouseCursor = true;
    }

    moveAfterCursor(event) {
        if (this._disabled || !this._visible)
            return;

        raf(() => this._positionTooltip(event))
    }

    afterRender() {
        this.$el.hide()
        this.$el.addClass("yellowTooltip tooltipTex noprint");
    }

    show() {
        if (!this._visible) {
            this._visible = true;
            if (!this._disabled)
                this.$el.show()
        }
    }

    hide() {
        if (this._visible) {
            this._visible = false;
            if (!this._disabled)
                this.$el.hide()
        }
    }

    enable() {
        this._disabled = false;
        if (this._visible)
            this.$el.show()
    }

    disable() {
        this._disabled = true;
        if (this._visible)
            this.$el.hide()
    }

    toggle(show) {
        if (show)
            this.enable()
        else
            this.disable()
    }

    setEnabled(enabled) {
        if (enabled)
            this.enable();
        else
            this.disable();
    }

    subscribeToMouseEvents($el, beforeShowCallback) {
        const showHandler = (e) => {
            if (beforeShowCallback)
                beforeShowCallback()
            if (this.autoFollowMouseCursor)
                this._positionTooltip(e)
            this.show()
        }
        const hideHandler = () => this.hide()
        const moveHandler = (e) => this.moveAfterCursor(e)

        $el.on('mouseenter', showHandler)
           .on('mouseleave', hideHandler)
           .on('wheel', hideHandler)

        if (this.autoFollowMouseCursor)
            $el.on('mousemove', moveHandler)

        return () => {
            $el.off('mouseenter', showHandler)
               .off('mousemove', moveHandler)
               .off('mouseleave', hideHandler)
               .off('wheel', hideHandler)
        }
    }

    _positionTooltip(event) {
        const tooltipWidth = this.$el.outerWidth()
        const tooltipHeight = this.$el.outerHeight()
        const xOffset = 15
        const yOffset = 15
        const minDistanceToBorderX = 15
        const minDistanceToBorderY = 15

        let x = event.clientX + xOffset
        if (x + tooltipWidth + minDistanceToBorderX > $(window).width())
            x -= tooltipWidth + xOffset

        let y = event.clientY + yOffset
        if (y + tooltipHeight + minDistanceToBorderY > $(window).height())
            y -= tooltipHeight + yOffset

        const top = y + getBodyScrollTop()
        const left = x + getBodyScrollLeft()

        // Via HTML instead jQuery for IE
        this.$el[0].style.top = `${top}px`
        this.$el[0].style.left = `${left}px`
    }
}


// WEBPACK FOOTER //
// ./web/js/Tooltip.js